import { useEffect, useState } from "react";

export function usePersistantState<T>(
  key: string,
  initialValue: T,
  storage: Storage = localStorage,
): [T, (value: T) => void] {
  const [state, setInternalState] = useState<T>(initialValue);

  // biome-ignore lint/correctness: would never change between storageType
  useEffect(() => {
    const initState = getPersistantState(key, storage);

    setInternalState(initState);
  }, [key]);

  const setState = (value: T) => {
    storage.setItem(key, JSON.stringify(value));
    setInternalState(value);
  };

  return [state, setState];
}

export const getPersistantState = (
  key: string,
  storage: Storage = localStorage,
) => {
  const value = storage.getItem(key);
  if (!value) return;
  return JSON.parse(value);
};

export const deletePersistantState = (
  key: string,
  storage: Storage = localStorage,
) => {
  storage.removeItem(key);
};
